var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"research-graph-block"},[_c('graph-triple-panel',{attrs:{"graph-title":_vm.graphTitle,"table-title":_vm.tableTitle,"graph-data":_vm.graphData,"triples":_vm.triples,"page-size":_vm.pageSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }